/* eslint-disable max-lines-per-function */
import { Avatar, Body, Card } from '@e2n/ui/v2';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import { KonfliktIndicator } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/KonfliktIndicator';

export function StationMitarbeiterCard({
  station,
  mitarbeiter,
  lehrjahr,
  beruf,
  currentStartOfWeek,
  currentEndOfWeek,
  abwesenheiten,
  konfliktStationen,
}: {
  station: ArbeitsbereichStation;
  mitarbeiter: Mitarbeiter;
  lehrjahr: string;
  beruf: Beruf;
  currentStartOfWeek: string;
  currentEndOfWeek: string;
  abwesenheiten: Abwesenheit[];
  konfliktStationen: ArbeitsbereichStation[];
}) {
  return (
    <Card>
      <div className="flex items-center gap-2">
        {mitarbeiter.imgUrl ? (
          <Avatar
            src={mitarbeiter.imgUrl}
            alt={mitarbeiter.getName()}
            fallbackInitials={mitarbeiter.getInitials()}
          />
        ) : (
          <Avatar type="initials" initials={mitarbeiter.getInitials()} />
        )}
        <div className="flex flex-col flex-1 gap-1 min-w-0">
          <Body className="truncate" weight="semibold">
            {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
          </Body>
          <Body className="text-labels-secondary truncate" size="sm">
            {lehrjahr + ' ⋅ ' + beruf.abkuerzung}
          </Body>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <FontAwesomeIcon
            className="size-2.5"
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
          />
          <Body size="sm" weight="semibold">
            {station.arbeitsbereich.name}
          </Body>
        </div>
        <div className="flex items-center gap-1 text-labels-secondary">
          <FontAwesomeIcon className="size-3.5" icon={faCalendarRange} />
          <Body className="text-labels-secondary" size="sm">
            {dayjs(station.von).format('DD.MM.YYYY') +
              ' – ' +
              dayjs(station.bis).format('DD.MM.YYYY')}
          </Body>
        </div>
        {abwesenheiten
          .filter(
            (abwesenheit) =>
              dayjs(abwesenheit.von).isSameOrBefore(currentEndOfWeek) &&
              dayjs(abwesenheit.bis).isSameOrAfter(currentStartOfWeek),
          )
          .map((abwesenheit) => (
            <div key={abwesenheit.id} className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                <FontAwesomeIcon
                  className="size-3.5"
                  icon={abwesenheit.abwesenheitsgrundIcon}
                />
                <Body size="sm" weight="semibold">
                  {abwesenheit.grund}
                </Body>
              </div>
              <Body className="text-labels-secondary" size="sm">
                {abwesenheit.zeitraumLabel}
              </Body>
            </div>
          ))}
        <div className="flex justify-start">
          <KonfliktIndicator konfliktStationen={konfliktStationen} />
        </div>
      </div>
    </Card>
  );
}
